class PackProductBenefits extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.dots = [];
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.onDotClick = this.onDotClick.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-benefit-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-benefit-dot]'));
    this.track = this.querySelector('[data-benefits-track]');

    if (!this.slides.length) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.onDotClick);
    });

    if (this.track) {
      this.track.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
    }

    this.showSlide(0);
  }

  disconnectedCallback() {
    this.dots.forEach((dot) => {
      dot.removeEventListener('click', this.onDotClick);
    });

    if (this.track) {
      this.track.removeEventListener('touchstart', this.onTouchStart);
      this.track.removeEventListener('touchend', this.onTouchEnd);
    }
  }

  onDotClick(event) {
    const index = Number(event.currentTarget.dataset.benefitDot);
    if (Number.isNaN(index)) return;
    this.showSlide(index);
  }

  onTouchStart(event) {
    const touch = event.changedTouches[0];
    this.touchStartX = touch.screenX;
    this.touchStartY = touch.screenY;
  }

  onTouchEnd(event) {
    if (this.slides.length < 2) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.screenX - this.touchStartX;
    const deltaY = touch.screenY - this.touchStartY;

    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

    if (deltaX < 0) {
      this.showSlide(Math.min(this.currentIndex + 1, this.slides.length - 1));
    } else {
      this.showSlide(Math.max(this.currentIndex - 1, 0));
    }
  }

  showSlide(index) {
    this.currentIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('pack-product-benefits')) {
  customElements.define('pack-product-benefits', PackProductBenefits);
}
